var exports = {
  "C3": "scrollContainer__KH81Rx",
  "ft": "embeddedScrollContainer__bd_uiN",
  "BM": "embeddedScrollContainerOverflowing___cndpS",
  "kL": "container__RhUkNO",
  "aD": "embeddedContainer__rF0z82",
  "vK": "banner__Z3gldT",
  "iW": "main__E9BDG4",
  "Ul": "withTaskList__BKVhDx",
  "YS": "embeddedMain__-xr4zM",
  "Qs": "content__FadutR",
  "m6": "embeddedContent__fp729R",
  "WH": "innerContainer__S4-nDS",
  "ct": "embeddedInnerContainer__P3nYXY",
  "jG": "inputAndStartersContainer__nPeeva",
  "yS": "embeddedInputContainer__C1FQRK",
  "mg": "embeddedDisclaimer__Fa8POv",
  "yg": "embeddedSuggestions__7XnX0q",
  "Xx": "commandStartersContainer__IojaHF",
  "$1": "promotionalBanner__7a2Zqa",
  "qr": "footer__oGyE8o",
  "Zq": "agentListContainer__UT-cdr",
  "h8": "failedTasksContainer__ysbhk5",
};

module.exports = exports;
